import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify, {
  options: {
    customProperties: true
  }
})

const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdiSvg' || 'fa', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
  theme: {
    dark: JSON.parse(localStorage.getItem('dark')),
    themes:
      {
        light: {
          primary: '#60DCD6',
          secondary: '#D2CDCA',
          accent: colors.shades.black,
          success: '#4CAF50',
          info: '#2196F3',
          warning: colors.yellow.darken3,
          error: colors.red.accent3,
          appBar: colors.grey.lighten5,
          warningFont: colors.grey.darken2,
          buttons: '#FFA6A0',
          invitationTitle: '#4DC5C1'
        },
        dark: {
          primary: '#609C92',
          secondary: colors.grey.darken3,
          accent: '#FF4081',
          success: '#4CAF50',
          info: '#2196F3',
          warning: colors.yellow.darken2,
          error: '#FF5252',
          appBar: colors.grey.darken1,
          warningFont: colors.grey.darken2,
          buttons: '#FFA6A0',
          invitationTitle: '#4DC5C1'
        }
      }
  }
})

export default vuetify
